module.exports = __webpack_public_path__ + "img/color_script.a4fb65ab.jpg";